import { render } from "./AccommodationAvailabilityWidget.vue?vue&type=template&id=18253bf2"
import script from "./AccommodationAvailabilityWidget.vue?vue&type=script&lang=js"
export * from "./AccommodationAvailabilityWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20251008-144825-d6d8f05a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__